import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Trophy, BookOpen } from 'lucide-react';
const tomos = [{
  id: 'T1',
  title: 'Renacimiento',
  color: 'bg-blue-500/10 text-blue-400 border-blue-500/20'
}, {
  id: 'T2',
  title: 'Cerebro Digital',
  color: 'bg-emerald-500/10 text-emerald-400 border-emerald-500/20'
}, {
  id: 'T3',
  title: 'Excel & IA',
  color: 'bg-amber-500/10 text-amber-400 border-amber-500/20'
}, {
  id: 'T4',
  title: 'Honorarios',
  color: 'bg-red-500/10 text-red-400 border-red-500/20'
}, {
  id: 'T5',
  title: 'Clientes',
  color: 'bg-purple-500/10 text-purple-400 border-purple-500/20'
}, {
  id: 'T6',
  title: '90 Días',
  color: 'bg-indigo-500/10 text-indigo-400 border-indigo-500/20'
}];
export function ProductOverview() {
  return <section className="py-16 bg-brand-darker border-t border-slate-800/50" data-id="element-271">
      <div className="container mx-auto px-4 max-w-4xl text-center" data-id="element-272">
        <FadeIn data-id="element-273">
          <div className="inline-flex items-center justify-center p-3 bg-brand-accent/10 rounded-full mb-6" data-id="element-274">
            <Trophy className="w-8 h-8 text-brand-accent" data-id="element-275" />
          </div>
          <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-276">
            LIBROFY.STORE™ MEGAPACK CONTADOR PRO
          </h2>
          <p className="text-xl text-slate-300 mb-2" data-id="element-277">
            <span className="font-bold text-white" data-id="element-278">6 Tomos + 4 Bonos</span> —
            Todo el sistema listo.
          </p>
          <p className="text-lg text-slate-400 mb-12" data-id="element-279">
            330+ páginas — Prompts + Macros + Protocolos + Honorarios resueltos.
          </p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-280">
          <div className="flex flex-wrap justify-center gap-3" data-id="element-281">
            {tomos.map(t => <div key={t.id} className={`flex items-center gap-2 px-4 py-2 rounded-full border ${t.color}`} data-id="element-282">
                <span className="font-bold" data-id="element-283">{t.id}</span>
                <span className="text-sm" data-id="element-284">{t.title}</span>
              </div>)}
          </div>
        </FadeIn>
      </div>
    </section>;
}